export interface AccessGroupRole {
  id: string;
  value: string;
  title: string;
  description: string;
}

export const ACCESS_GROUP_ROLES: AccessGroupRole[] = [
  {
    id: '1',
    value: 'spm_operator',
    title: 'AISPM Operator',
    description:
      'A user who can view all SPM data and perform actions on AISPM violations and resources, but cannot create, delete, or update integrations.',
  },
  {
    id: '3',
    value: 'spm_viewer',
    title: 'AISPM Viewer',
    description:
      'A read-only user who can view all AISPM data except integration details and cannot perform any actions.',
  },
  {
    id: '4',
    value: 'aidr_operator',
    title: 'AIDR Operator',
    description:
      'A user who can view all AIDR data and perform actions on AIDR violations and resources, but cannot create, delete, or update integrations.',
  },
  {
    id: '5',
    value: 'aidr_analyst',
    title: 'AIDR Analyst',
    description:
      'A user with read access to all AIDR data required for analysis-including sensitive details-who can investigate and triage AIDR violations but cannot make any modifications.',
  },
  {
    id: '6',
    value: 'aidr_viewer',
    title: 'AIDR Viewer',
    description:
      'A read-only user who can view all AIDR data except integration details and cannot perform any actions.',
  },
  {
    id: '7',
    value: 'global_operator',
    title: 'Global Operator',
    description:
      'Can view all AISPM and AIDR data and perform actions on violations and resources across both domains, but cannot access Admin settings or manage integrations.',
  },
  {
    id: '8',
    value: 'global_analyst',
    title: 'Global Analyst',
    description:
      'Can view all data required for analysis across AISPM and AIDR (including sensitive information) and can investigate and triage violations, but cannot make any modifications.',
  },
  {
    id: '9',
    value: 'global_viewer',
    title: 'Global Viewer',
    description:
      'Has read-only access to all AISPM and AIDR data, excluding Admin-related information, and cannot perform any actions.',
  },
];

export const ACCESS_GROUP_ROLE_MAP: Record<string, string> = ACCESS_GROUP_ROLES.reduce(
  (acc, role) => {
    acc[role.id] = role.title;
    return acc;
  },
  {} as Record<string, string>
);

export const ROLE_NAME_TO_ID_MAP: Record<string, string> = ACCESS_GROUP_ROLES.reduce(
  (acc, role) => {
    acc[role.value] = role.id;
    return acc;
  },
  {} as Record<string, string>
);

export const ROLE_ID_TO_NAME_MAP: Record<string, string> = ACCESS_GROUP_ROLES.reduce(
  (acc, role) => {
    acc[role.id] = role.value;
    return acc;
  },
  {} as Record<string, string>
);

export function getRoleDisplayName(roleId: string): string {
  return ACCESS_GROUP_ROLE_MAP[roleId] || `Role ${roleId}`;
}

export function getRoleIdByName(roleName: string): string {
  return ROLE_NAME_TO_ID_MAP[roleName] || '';
}

export function getRoleNameById(roleId: string): string {
  return ROLE_ID_TO_NAME_MAP[roleId] || '';
}

export const ROLE_ID_TO_DESCRIPTION_MAP: Record<string, string> = ACCESS_GROUP_ROLES.reduce(
  (acc, role) => {
    acc[role.id] = role.description;
    return acc;
  },
  {} as Record<string, string>
);

export function getRoleDescriptionById(roleId: string): string {
  return ROLE_ID_TO_DESCRIPTION_MAP[roleId] || '';
}
